/** UploadThing CDN URL patterns (utfs.io legacy + *.ufs.sh current). */
const UPLOAD_FILE_URL_REGEX =
  /https:\/\/(?:utfs\.io|[a-z0-9-]+\.ufs\.sh|[a-z0-9-]+\.utf-staging\.com)\/f\/([A-Za-z0-9_-]+)/gi;

const UPLOAD_FILE_URL_SINGLE =
  /https:\/\/(?:utfs\.io|[a-z0-9-]+\.ufs\.sh|[a-z0-9-]+\.utf-staging\.com)\/f\/([A-Za-z0-9_-]+)/i;

export function collectUrlsFromHtml(html: string | undefined | null): string[] {
  if (!html) return [];
  const matches = html.matchAll(new RegExp(UPLOAD_FILE_URL_REGEX.source, 'gi'));
  return [...new Set([...matches].map(match => match[0]))];
}

export function extractUploadFileKey(url: string): string | null {
  const match = url.match(UPLOAD_FILE_URL_SINGLE);
  return match?.[1] ?? null;
}
